import actionTypes from './actionTypes';

export default {
  sendError: (error, errorInfo) => (dispatch) => {
    dispatch({
      type: actionTypes.updateStatus,
      error,
      errorInfo,
      loading: false
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/actions/status_Actions.js